import React from 'react'

const RadioUnselected = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="#0D1536" fillOpacity=".65" fillRule="evenodd" d="M12 20.8c4.86 0 8.8-3.94 8.8-8.8 0-4.86-3.94-8.8-8.8-8.8-4.86 0-8.8 3.94-8.8 8.8 0 4.86 3.94 8.8 8.8 8.8zm0 1.2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" clipRule="evenodd"/>
  </svg>
)
export default RadioUnselected
